module.exports = __webpack_public_path__ + "2836528ad13278d88bcc509dc3f8102b.ttf";